import Splide from "@splidejs/splide";

export default class PartnerSlider {
    static init(): void {
        const slider: HTMLElement | null = document.querySelector(".js-partner-slider-splide");
        if (!slider) return;

        const images = slider.querySelectorAll<HTMLImageElement>(".partner-slider__img");
        if (!images.length) return;

        const list = slider.querySelector(".partner-slider__items") as HTMLElement | null;
        let splide: Splide;

        // width of all images together
        const items = slider.querySelectorAll(".partner-slider__item");
        let itemsWidth = items.length * 10; // 10px margin
        items.forEach(item => {
            itemsWidth += item.clientWidth;
        });


        if (itemsWidth <= slider.clientWidth) {
            splide = new Splide(slider, {
                drag: false,
                autoWidth: true,
                pagination: false,
                arrows: false,
                autoplay: false,
            });
            if (list) {
                list.style.justifyContent = "center";
            }
        } else {
            splide = new Splide(slider, {
                type: "loop",
                drag: "free",
                focus: "center",
                autoWidth: true,
                pagination: false,
                arrows: false,
                autoplay: true,
                interval: 2000,
                perMove: 1,
                pauseOnHover: false,
                pauseOnFocus: false
            });
        }

        splide.mount();

        images.forEach(img => {
            img.onload = () => splide.refresh();
        });
    }
}
